import { render, staticRenderFns } from "./UsersTree.vue?vue&type=template&id=4f4af07f&scoped=true"
import script from "./UsersTree.vue?vue&type=script&lang=js"
export * from "./UsersTree.vue?vue&type=script&lang=js"
import style0 from "./UsersTree.vue?vue&type=style&index=0&id=4f4af07f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4af07f",
  null
  
)

export default component.exports